import { slugify } from "@certn/utils";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { TextFieldControl } from "./TextFieldControl";
import {
  CascadiaControlProps,
  withCascadiaControlProps,
} from "../wrappers/withCascadiaControlProps";

function UrlControl(props: CascadiaControlProps) {
  const { t } = useTranslation();
  const getIsValidURL = (url: string): boolean => {
    if (!url) return true;
    const urlRegex =
      /^(http:\/\/|https:\/\/)?([\w_-]+(?:(?:\.[\w_-]+)+))([\w.,@?^=%&:/~+#-]*[\w@?^=%&/~+#-])/;
    return urlRegex.test(url);
  };

  const urlIsInvalid = useMemo(() => {
    return !getIsValidURL(props.data);
  }, [props.data]);

  const urlIsInvalidError = useMemo(() => {
    return urlIsInvalid ? t("Invalid URL") : null;
  }, [urlIsInvalid]);

  return (
    <>
      <TextFieldControl
        {...props}
        invalid={urlIsInvalid}
        setValue={(value: string) => {
          const isValidURL = getIsValidURL(value);
          if (
            isValidURL &&
            value.substring(0, 4) !== "http" &&
            value.length > 1
          ) {
            value = "https://" + value;
          }
          props.setValue(value);
        }}
        errors={[...props.errors, urlIsInvalidError ?? ""]}
        data-testid={`website-${slugify(props.path)}-input`}
      />
    </>
  );
}

export const UrlControlRenderer = withCascadiaControlProps(UrlControl);
